/* GENERATED FILE — do not edit here.
   Source: worker/src/ui.js   Rebuild: node build/build-theme.mjs */

(function () {
  'use strict';

  var STORE_KEY = 'orjn_track_last';

  function h(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }

  function tokenFromLocation() {
    var qs = new URLSearchParams(window.location.search);
    var t = qs.get('t') || qs.get('token');
    if (t) return t.trim();
    var m = window.location.pathname.match(/\/t\/([A-Za-z0-9_-]{8,})/);
    return m ? m[1] : '';
  }

  function remember(token, order) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify({
        token: token,
        reference: (order && order.reference) || '',
        item: (order && order.item) || '',
        image: (order && order.image) || ''
      }));
    } catch (e) {}
  }

  function recalled() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function firstName(name) {
    if (!name) return '';
    return String(name).trim().split(/\s+/)[0];
  }

  function beirutDateTime(value) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Beirut',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(date) + ' Beirut time';
  }

  // Offered ONLY when the store told us nobody is signed in. A customer who is already
  // logged in is looking at their own order list, so asking them to sign in again would
  // be nonsense — the Liquid template simply omits the URL in that case.
  function signinBlock(cfg) {
    if (!cfg.signinUrl) return null;
    var wrap = h('div', 'ot-signin');
    // h(tag, className, text) — the sentence is the THIRD argument. Passing it second
    // made it the CSS class, so the prompt rendered as an empty line above the button.
    wrap.appendChild(h('p', null, cfg.signinText || 'Have an account? Sign in and all your orders appear here automatically — nothing to type.'));
    var link = h('a', null, cfg.signinLabel || 'Sign in');
    link.href = cfg.signinUrl;
    wrap.appendChild(link);
    return wrap;
  }

  function whatsappBlock(cfg, order) {
    if (!cfg.whatsapp) return null;
    var wrap = h('div', 'ot-help');
    wrap.appendChild(h('p', null, cfg.helpText || 'Any question about this order? Message us and we will answer.'));

    var msg = cfg.helpMessage || 'Hi ORJN, I have a question about my order';
    if (order && order.reference) msg += ' ' + order.reference;

    var a = h('a', 'ot-wa', cfg.whatsappLabel || 'Chat on WhatsApp');
    a.href = 'https://wa.me/' + String(cfg.whatsapp).replace(/[^0-9]/g, '') + '?text=' + encodeURIComponent(msg);
    a.target = '_blank';
    a.rel = 'noopener';
    wrap.appendChild(a);
    return wrap;
  }

  function loading(root) {
    root.textContent = '';
    var p = h('div', 'ot-panel');
    for (var i = 0; i < 3; i++) p.appendChild(h('div', 'ot-skeleton'));
    root.appendChild(p);
  }

  /* ------------------------------------------------------------- the form */

  function showForm(root, cfg, errorMessage) {
    root.textContent = '';

    // Signed in, but the store handed us no orders for this account. Saying nothing and
    // showing a bare order-number box reads as "it is broken" — the customer just signed
    // in and got the same screen back. Two real reasons this happens: the account is new,
    // or they ordered without signing in, in which case the order is not attached to it
    // and only the order number will find it.
    if (cfg.signedIn && !myOrderNumbers().length) {
      var none = h('div', 'ot-signin');
      none.appendChild(h('p', null, cfg.noOrdersText ||
        'You are signed in, but there are no orders on this account yet. If you ordered without signing in, enter your order number below and we will find it.'));
      root.appendChild(none);
    }

    var form = h('form', 'ot-form');
    form.setAttribute('novalidate', 'novalidate');

    if (errorMessage) form.appendChild(h('p', 'ot-error', errorMessage));

    form.appendChild(h('p', 'ot-form-intro',
      cfg.formIntro || (cfg.requireContact ? 'Enter your order number, and the phone number or email you ordered with.' : 'Enter your order number to see where your pair is.')));

    function field(labelText, name, placeholder, mode) {
      var wrap = h('div', 'ot-field');
      var label = h('label', 'ot-label', labelText);
      label.setAttribute('for', 'ot-' + name);
      var input = h('input', 'ot-input');
      input.id = 'ot-' + name;
      input.name = name;
      input.placeholder = placeholder;
      input.autocomplete = name === 'phone' ? 'tel' : 'off';
      if (mode) input.inputMode = mode;
      wrap.appendChild(label);
      wrap.appendChild(input);
      form.appendChild(wrap);
      return input;
    }

    var refInput = field('Order number', 'order_number', 'e.g. 1042', 'text');
    var contactInput = null;
    if (cfg.requireContact) {
      contactInput = field(cfg.contactLabel || 'Phone or email', 'contact', 'e.g. 03 123 456', 'text');
    }

    var submit = h('button', 'ot-submit', cfg.submitLabel || 'Track my order');
    submit.type = 'submit';
    form.appendChild(submit);

    form.appendChild(h('p', 'ot-hint',
      cfg.formHint || (cfg.requireContact ? 'Either your phone or your email works.' : 'You will find your order number on your order confirmation email.')));

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var ref = refInput.value.trim();
      var contact = contactInput ? contactInput.value.trim() : '';

      // Only the first field is required here. The phone is checked by the server, so
      // that the owner's door code (typed alone) is considered before this page can
      // complain about an empty phone. The server still requires it for a real lookup.
      if (!ref) {
        showForm(root, cfg, 'Please enter your order number.');
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Checking…';

      var base = cfg.api.replace(/\/+$/, '');
      fetch(base + '/api/lookup', {
        method: 'POST',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify({ order_number: ref, contact: contact })
      })
        .then(function (res) { return res.json().then(function (b) { return { status: res.status, body: b }; }); })
        .then(function (r) {
          if (r.status === 429) {
            showForm(root, cfg, 'Too many attempts. Please wait a few minutes, or message us on WhatsApp.');
            return;
          }

          // The owner typed the door code. Hand over to the panel's sign-in.
          if (r.body && r.body.owner && r.body.adminUrl) {
            submit.textContent = 'Opening dashboard…';
            window.location.href = r.body.adminUrl;
            return;
          }

          if (r.status === 400) {
            showForm(root, cfg, 'Please fill in both fields.');
            return;
          }

          // Several pairs on one order — let them choose instead of guessing for them.
          if (r.body && r.body.multiple && r.body.orders && r.body.orders.length) {
            showChooser(root, cfg, r.body);
            return;
          }

          if (r.status === 404 || !r.body || !r.body.ok) {
            showForm(root, cfg, (cfg.requireContact ? 'We could not find an order with those details. Check the order number, and the phone or email you ordered with.' : 'We could not find that order number. Check your order confirmation email, or message us on WhatsApp.'));
            return;
          }

          if (r.body.token) {
            remember(r.body.token, r.body.order);
            // Deep-link the URL so a refresh or a bookmark goes straight back in.
            try {
              var url = new URL(window.location.href);
              url.searchParams.set('t', r.body.token);
              window.history.replaceState(null, '', url.toString());
            } catch (e) {}
          }
          render(root, cfg, r.body, true);
        })
        .catch(function () {
          showForm(root, cfg, 'Something went wrong. Please try again in a moment.');
        });
    });

    root.appendChild(form);

    // Returning customer: one tap back into the order they checked last time.
    var last = recalled();
    if (last && last.token) {
      var again = h('button', 'ot-recent');
      again.type = 'button';

      if (last.image) {
        var lastThumb = document.createElement('img');
        lastThumb.className = 'ot-thumb';
        lastThumb.src = last.image;
        lastThumb.alt = '';
        lastThumb.loading = 'lazy';
        lastThumb.onerror = function () { lastThumb.remove(); };
        again.appendChild(lastThumb);
      }

      var lastBody = h('div', 'ot-recent-body');
      lastBody.appendChild(h('span', null, 'Continue tracking'));
      lastBody.appendChild(h('strong', null, last.item || last.reference || 'your order'));
      if (last.item && last.reference) lastBody.appendChild(h('span', 'ot-recent-ref', last.reference));
      again.appendChild(lastBody);
      again.appendChild(h('span', 'ot-pick-arrow', '→'));

      again.addEventListener('click', function () { load(root, cfg, last.token, true); });
      root.appendChild(again);
    }

    var formSignin = signinBlock(cfg);
    if (formSignin) root.appendChild(formSignin);

    var help = whatsappBlock(cfg, null);
    if (help) root.appendChild(help);
  }

  /* ------------------------------------------- several pairs in one order */

  function showChooser(root, cfg, data) {
    root.textContent = '';

    var wrap = h('div', 'ot-choose');
    wrap.appendChild(h('p', 'ot-status-label', 'Your order'));
    wrap.appendChild(h('p', null,
      'This order has ' + data.orders.length + ' pairs. Pick one to see where it is.'));

    data.orders.forEach(function (o) {
      var stage = (data.stages[o.stageIndex] || {}).label || '';

      var btn = h('button', 'ot-pick');
      btn.type = 'button';

      if (o.image) {
        var th = document.createElement('img');
        th.className = 'ot-thumb';
        th.src = o.image;
        th.alt = '';
        th.loading = 'lazy';
        th.onerror = function () { th.remove(); };
        btn.appendChild(th);
      }

      var body = h('div', 'ot-pick-body');
      body.appendChild(h('p', 'ot-pick-item', o.item));
      if (stage) body.appendChild(h('p', 'ot-pick-stage', stage));
      btn.appendChild(body);

      if (o.size) btn.appendChild(h('span', 'ot-pick-size', o.size));
      btn.appendChild(h('span', 'ot-pick-arrow', '\u2192'));

      btn.addEventListener('click', function () {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('t', o.token);
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}
        load(root, cfg, o.token, true);
      });

      wrap.appendChild(btn);
    });

    root.appendChild(wrap);

    var chooserSignin = signinBlock(cfg);
    if (chooserSignin) root.appendChild(chooserSignin);

    var help = whatsappBlock(cfg, null);
    if (help) root.appendChild(help);
  }

  /* ------------------------- signed-in customer: every pair they ordered */

  // Shopify renders the signed-in customer's own order numbers into the page, so this
  // list is decided by Shopify — not by anything the browser could tamper with.
  function myOrderNumbers() {
    var el = document.getElementById('orjn-my-orders');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (e) { return []; }
  }

  function showMyOrders(root, cfg, data, name) {
    root.textContent = '';

    var wrap = h('div', 'ot-choose');
    wrap.appendChild(h('p', 'ot-status-label', name ? name + ', your orders' : 'Your orders'));
    wrap.appendChild(h('p', null,
      data.orders.length === 1
        ? 'Tap it to see where it is.'
        : 'You have ' + data.orders.length + ' pairs with us. Tap one to see where it is.'));

    data.orders.forEach(function (o) {
      var stage = (data.stages[o.stageIndex] || {}).label || '';

      var btn = h('button', 'ot-pick');
      btn.type = 'button';

      if (o.image) {
        var th2 = document.createElement('img');
        th2.className = 'ot-thumb';
        th2.src = o.image;
        th2.alt = '';
        th2.loading = 'lazy';
        th2.onerror = function () { th2.remove(); };
        btn.appendChild(th2);
      }

      var body = h('div', 'ot-pick-body');
      body.appendChild(h('p', 'ot-pick-item', o.item));
      var line = stage + (o.reference ? '  ·  ' + o.reference : '');
      body.appendChild(h('p', 'ot-pick-stage', line));
      if (o.note) {
        var flag = h('p', 'ot-pick-stage', o.note);
        flag.style.color = 'var(--ot-infra)';
        body.appendChild(flag);
      }
      btn.appendChild(body);

      if (o.size) btn.appendChild(h('span', 'ot-pick-size', o.size));
      btn.appendChild(h('span', 'ot-pick-arrow', '\u2192'));

      btn.addEventListener('click', function () {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('t', o.token);
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}
        load(root, cfg, o.token, true);
      });

      wrap.appendChild(btn);
    });

    root.appendChild(wrap);

    var help = whatsappBlock(cfg, null);
    if (help) root.appendChild(help);
  }

  function loadMine(root, cfg, numbers, name) {
    loading(root);

    var base = cfg.api.replace(/\/+$/, '');
    fetch(base + '/api/orders', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ order_numbers: numbers })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || !data.ok || !data.orders || !data.orders.length) {
          // Signed in, but nothing of theirs is being tracked yet.
          panel(root, 'Nothing to track yet',
            'We have not started tracking anything on your account yet. As soon as we do it will show up here.');
          var help = whatsappBlock(cfg, null);
          if (help) root.appendChild(help);
          return;
        }
        if (data.orders.length === 1) {
          load(root, cfg, data.orders[0].token, true);
          return;
        }
        showMyOrders(root, cfg, data, name);
      })
      .catch(function () {
        showForm(root, cfg, 'We could not load your orders right now. Please try again in a moment.');
      });
  }

  /* ---------------------------------------------------------- the tracker */

  function render(root, cfg, data, cameFromForm) {
    var order = data.order;
    var stages = data.stages || [];
    root.textContent = '';

    // -- summary ------------------------------------------------------------
    var summary = h('div', 'ot-summary');
    var srow = h('div', 'ot-summary-row');

    if (order.image) {
      var photo = document.createElement('img');
      photo.className = 'ot-photo';
      photo.src = order.image;
      photo.alt = order.item || '';
      photo.loading = 'lazy';
      // A dead image URL should leave no gap and no broken-image icon.
      photo.onerror = function () { photo.remove(); };
      srow.appendChild(photo);
    }

    var stext = h('div', 'ot-summary-text');
    var greeting = firstName(order.firstName);
    if (greeting) stext.appendChild(h('p', 'ot-status-label', greeting + ', here is your pair'));
    stext.appendChild(h('h2', 'ot-item', order.item || 'Your order'));

    var meta = h('div', 'ot-meta');
    function chip(label, value) {
      if (!value) return;
      var c = h('span', 'ot-chip');
      c.appendChild(document.createTextNode(label + ' '));
      c.appendChild(h('strong', null, value));
      meta.appendChild(c);
    }
    chip('Order', order.reference);
    chip('Size', order.size);
    if (meta.childNodes.length) stext.appendChild(meta);

    srow.appendChild(stext);
    summary.appendChild(srow);
    root.appendChild(summary);

    var journey = order.journey || {};
    var current = journey.current || { title: '', detail: '', location: '', at: '' };

    // -- headline status ----------------------------------------------------
    var status = h('div', 'ot-status');
    status.appendChild(h('p', 'ot-status-label', 'Current status'));
    status.appendChild(h('p', 'ot-status-value', current.title));
    if (current.detail) status.appendChild(h('p', 'ot-status-blurb', current.detail));
    if (current.location || current.at) {
      status.appendChild(h('p', 'ot-status-meta', (current.location || '') + (current.location && current.at ? '  ·  ' : '') + beirutDateTime(current.at)));
    }
    root.appendChild(status);

    // -- route --------------------------------------------------------------
    if (journey.route) {
      var route = h('div', 'ot-route');
      var origin = h('div', 'ot-route-point');
      origin.appendChild(h('span', 'ot-route-kicker', 'Origin network'));
      origin.appendChild(h('strong', null, journey.route.origin || 'United States'));
      route.appendChild(origin);
      route.appendChild(h('div', 'ot-route-arrow', '→'));
      var gateway = h('div', 'ot-route-point');
      gateway.appendChild(h('span', 'ot-route-kicker', 'Transit gateway'));
      gateway.appendChild(h('strong', null, (journey.route.gatewayCode || 'DXB') + ' · ' + (journey.route.gateway || 'Dubai')));
      route.appendChild(gateway);
      route.appendChild(h('div', 'ot-route-arrow', '→'));
      var destination = h('div', 'ot-route-point');
      destination.appendChild(h('span', 'ot-route-kicker', 'Final destination'));
      destination.appendChild(h('strong', null, journey.route.destination || 'Beirut, Lebanon'));
      route.appendChild(destination);
      root.appendChild(route);
    }

    // -- exception notice ---------------------------------------------------
    if (order.note) {
      var notice = h('div', 'ot-notice');
      notice.appendChild(h('p', 'ot-notice-label', 'Update'));
      notice.appendChild(h('p', null, order.note));
      root.appendChild(notice);
    }

    // -- detailed journey activity ----------------------------------------
    if (journey.events && journey.events.length) {
      var activity = h('section', 'ot-activity');
      activity.appendChild(h('h3', 'ot-section-title', 'Shipment activity'));
      var eventList = h('ol', 'ot-events');
      journey.events.slice().reverse().forEach(function (event) {
        var eventRow = h('li', 'ot-event' + (event.confirmed ? ' is-confirmed' : ''));
        var eventRail = h('div', 'ot-event-rail');
        eventRail.appendChild(h('span', 'ot-event-dot'));
        eventRow.appendChild(eventRail);
        var eventBody = h('div', 'ot-event-body');
        eventBody.appendChild(h('p', 'ot-event-time', beirutDateTime(event.at)));
        eventBody.appendChild(h('p', 'ot-event-title', event.title));
        if (event.location) eventBody.appendChild(h('p', 'ot-event-location', event.location));
        if (event.detail) eventBody.appendChild(h('p', 'ot-event-detail', event.detail));
        eventBody.appendChild(h('span', 'ot-event-kind', event.confirmed ? 'Confirmed update' : 'ORJN journey update'));
        eventRow.appendChild(eventBody);
        eventList.appendChild(eventRow);
      });
      activity.appendChild(eventList);
      root.appendChild(activity);
    }

    // -- help ---------------------------------------------------------------
    var help = whatsappBlock(cfg, order);
    if (help) root.appendChild(help);

    if (cameFromForm) {
      var back = h('button', 'ot-back', myOrderNumbers().length ? 'Back to my orders' : 'Track another order');
      back.type = 'button';
      back.addEventListener('click', function () {
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete('t');
          window.history.replaceState(null, '', url.toString());
        } catch (e) {}
        var mine = myOrderNumbers();
        if (mine.length) loadMine(root, cfg, mine, root.getAttribute('data-customer-name') || '');
        else showForm(root, cfg, '');
      });
      root.appendChild(back);
    }
  }

  /* ------------------------------------------------------------- load flow */

  function load(root, cfg, token, cameFromForm) {
    loading(root);

    var base = cfg.api.replace(/\/+$/, '');
    fetch(base + '/api/track/' + encodeURIComponent(token), { headers: { accept: 'application/json' } })
      .then(function (res) {
        if (res.status === 404 || res.status === 400) return { gone: true };
        if (!res.ok) throw new Error('http ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data && data.gone) {
          showForm(root, cfg, 'That tracking link is no longer valid. Enter your order number and phone instead.');
          return;
        }
        if (!data || !data.ok || !data.order) throw new Error('bad payload');
        remember(token, data.order);
        render(root, cfg, data, cameFromForm);
      })
      .catch(function () {
        showForm(root, cfg, 'We could not load your order right now. Please try again in a moment.');
      });
  }

  function boot(root) {
    var cfg = {
      api: root.getAttribute('data-api') || '',
      whatsapp: root.getAttribute('data-whatsapp') || '',
      whatsappLabel: root.getAttribute('data-whatsapp-label') || '',
      helpText: root.getAttribute('data-help-text') || '',
      helpMessage: root.getAttribute('data-help-message') || '',
      formIntro: root.getAttribute('data-form-intro') || '',
      contactLabel: root.getAttribute('data-contact-label') || '',
      requireContact: root.getAttribute('data-require-contact') !== 'false',
      signinUrl: root.getAttribute('data-signin-url') || '',
      signinText: root.getAttribute('data-signin-text') || '',
      signinLabel: root.getAttribute('data-signin-label') || '',
      signedIn: root.getAttribute('data-signed-in') === 'true',
      formHint: root.getAttribute('data-form-hint') || '',
      noOrdersText: root.getAttribute('data-no-orders-text') || '',
      submitLabel: root.getAttribute('data-submit-label') || ''
    };

    var token = tokenFromLocation();
    if (token) { load(root, cfg, token, false); return; }

    // Signed in on the store? Show everything they have, no typing at all.
    var mine = myOrderNumbers();
    if (mine.length) { loadMine(root, cfg, mine, root.getAttribute('data-customer-name') || ''); return; }

    showForm(root, cfg, '');
  }

  function init() {
    var roots = document.querySelectorAll('[data-orjn-track]');
    for (var i = 0; i < roots.length; i++) boot(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
